'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _isUndefined2 = require('lodash/isUndefined');

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

var _get3 = require('lodash/get');

var _get4 = _interopRequireDefault(_get3);

exports.default = reducer;
exports.updatePosition = updatePosition;
exports.playStartStat = playStartStat;
exports.playStopStat = playStopStat;
exports.playPauseStat = playPauseStat;
exports.playUnpauseStat = playUnpauseStat;
exports.playPlayStat = playPlayStat;
exports.stop = stop;
exports.albumEnded = albumEnded;
exports.albumDenied = albumDenied;
exports.flushAlbumDeniedFlag = flushAlbumDeniedFlag;
exports.togglePause = togglePause;
exports.playAlbum = playAlbum;
exports.playPause = playPause;
exports.setVolume = setVolume;
exports.seek = seek;
exports.play = play;
exports.playNext = playNext;
exports.playPrev = playPrev;
exports.toggleExpand = toggleExpand;
exports.updateAlbumName = updateAlbumName;

var _loadReducer = require('../loadReducer');

var _loadReducer2 = _interopRequireDefault(_loadReducer);

var _AudioPlayer = require('helpers/AudioPlayer');

var _AudioPlayer2 = _interopRequireDefault(_AudioPlayer);

var _playstats = require('./playstats');

var _auth = require('./auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Audioplayer redux reducer and action creators. Dealing with audioplayer helper */

var PLAY_ALBUM = 'audioplayer/PLAY_ALBUM';
var PLAY_TRACK = 'audioplayer/PLAY_TRACK';
var SET_VOLUME = 'audioplayer/SET_VOLUME';
var SEEK = 'audioplayer/SEEK';
var PLAY_NEXT = 'audioplayer/PLAY_NEXT';
var PLAY_PREV = 'audioplayer/PLAY_PREV';
var UPDATE_POSITION = 'audioplayer/UPDATE_POSITION';
var PAUSE = 'audioplayer/PAUSE';
var PLAY = 'audioplayer/PLAY';
var STOP = 'audioplayer/STOP';
var TOGGLE_EXPAND = 'audioplayer/TOGGLE_EXPAND';
var ALBUM_ENDED = 'audioplayer/ALBUM_ENDED';
var ALBUM_DENIED = 'audioplayer/ALBUM_DENIED';
var FLUSH_ALBUM_DENIED_FLAG = 'audioplayer/FLUSH_ALBUM_DENIED_FLAG';
var UPDATE_ALBUM_NAME = 'audioplayer/UPDATE_ALBUM_NAME';

var positionInterval = null;
var playStatInterval = null;
var endedHandler = function endedHandler() {};
var playStatDelay = 10000;

var loadReducer = (0, _loadReducer2.default)('audioplayer', {
  playStartStat: { keepOnLoad: true },
  playStopStat: {},
  playPauseStat: {},
  playUnpauseStat: {},
  playPlayStat: {}
});

var initialState = {
  album: {},
  lastAlbum: {},
  tracks: [],
  lastTracks: [],
  playerStatus: _AudioPlayer2.default.status.stop,
  volume: _AudioPlayer2.default.volume(),
  currentTrackIndex: 0,
  position: 0,
  humanizedPosition: '0:00',
  expanded: false,
  playSession: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case PLAY_ALBUM:
      return (0, _extends3.default)({}, state, {
        album: action.album,
        tracks: action.tracks,
        playerStatus: _AudioPlayer2.default.status.play,
        currentTrackIndex: action.currentTrackIndex,
        isAlbumEnded: false,
        isAlbumDenied: false
      });
    case PLAY_TRACK:
      return (0, _extends3.default)({}, state, {
        playerStatus: _AudioPlayer2.default.status.play,
        currentTrackIndex: action.currentTrackIndex,
        isAlbumEnded: false,
        isAlbumDenied: false
      });
    case PLAY_NEXT:
      {
        var nextTrackIndex = state.tracks.length > state.currentTrackIndex + 1 ? state.currentTrackIndex + 1 : 0;
        return (0, _extends3.default)({}, state, {
          currentTrackIndex: nextTrackIndex,
          playerStatus: _AudioPlayer2.default.status.play,
          isAlbumEnded: false,
          isAlbumDenied: false
        });
      }
    case PLAY_PREV:
      {
        var prevTrackIndex = state.currentTrackIndex === 0 ? state.tracks.length - 1 : state.currentTrackIndex - 1;
        return (0, _extends3.default)({}, state, {
          currentTrackIndex: prevTrackIndex,
          playerStatus: _AudioPlayer2.default.status.play,
          isAlbumEnded: false,
          isAlbumDenied: false
        });
      }
    case SET_VOLUME:
      return (0, _extends3.default)({}, state, {
        volume: action.volume,
        isVolumeNeedUpdate: action.isVolumeNeedUpdate
      });
    case SEEK:
      return (0, _extends3.default)({}, state, {
        position: action.position,
        preventUpdate: action.preventUpdate
      });
    case UPDATE_POSITION:
      return (0, _extends3.default)({}, state, {
        position: action.position,
        humanizedPosition: action.humanizedPosition
      });
    case PAUSE:
      return (0, _extends3.default)({}, state, {
        playerStatus: _AudioPlayer2.default.status.pause
      });
    case STOP:
      return (0, _extends3.default)({}, state, initialState, {
        lastAlbum: state.album,
        lastTracks: state.tracks
      });
    case PLAY:
      return (0, _extends3.default)({}, state, {
        playerStatus: _AudioPlayer2.default.status.play,
        isAlbumEnded: false,
        isAlbumDenied: false
      });
    case TOGGLE_EXPAND:
      return (0, _extends3.default)({}, state, {
        expanded: !state.expanded
      });
    case ALBUM_ENDED:
      return (0, _extends3.default)({}, state, {
        isAlbumEnded: action.isAlbumEnded
      });
    case ALBUM_DENIED:
      return (0, _extends3.default)({}, state, {
        isAlbumDenied: true
      });
    case FLUSH_ALBUM_DENIED_FLAG:
      return (0, _extends3.default)({}, state, {
        isAlbumDenied: false
      });
    case UPDATE_ALBUM_NAME:
      return (0, _extends3.default)({}, state, {
        album: (0, _extends3.default)({}, state.album, {
          name: action.name,
          artist_name: action.name
        })
      });
    case loadReducer.constants.PLAY_START_STAT:
      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
        playSession: null
      });
    case loadReducer.constants.PLAY_START_STAT_SUCCESS:
      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
        playSession: (0, _get4.default)(action, 'result.data.session')
      });
    case loadReducer.constants.PLAY_STOP_STAT:
      return (0, _extends3.default)({}, loadReducer.reducer(state, action), {
        playSession: null
      });
    default:
      return state;
  }
}

function updatePosition(position) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_POSITION,
      position: position,
      humanizedPosition: _AudioPlayer2.default.getHumanizedPosition(position)
    });
  };
}

function getStatRequestParams(_ref) {
  var trackNumber = _ref.trackNumber;

  return function (dispatch, getState) {
    var globalState = getState();
    var track = (0, _get4.default)(globalState, ['audioplayer', 'tracks', trackNumber], {});
    var wFilename = track.wFileName || '';
    var recipientId = (0, _get4.default)(globalState, ['audioplayer', 'album', 'recipient_id'], 0) || track.recipientId;
    var contentKey = (0, _get4.default)(globalState, ['audioplayer', 'album', 'contentKey']) || track.contentKey;
    return { wFilename: wFilename, recipientId: recipientId, contentKey: contentKey };
  };
}

function getStatRequestData(_ref2) {
  var trackNumber = _ref2.trackNumber,
      session = _ref2.session;

  return function (dispatch) {
    var _dispatch = dispatch(getStatRequestParams({ trackNumber: trackNumber })),
        wFilename = _dispatch.wFilename,
        contentKey = _dispatch.contentKey;

    return {
      session: session,
      wFilename: wFilename,
      track_number: trackNumber + 1,
      key: contentKey
    };
  };
}

function playStartStat(trackNumber) {
  return function (dispatch) {
    var data = dispatch(getStatRequestData({ trackNumber: trackNumber }));
    var isUser = dispatch((0, _auth.isLoggedIn)());
    dispatch({
      types: loadReducer.constantsByKey.playStartStat,
      promise: function promise(client) {
        return client.post(isUser ? 'viewer_wa/play_start' : 'auth/play_start', { data: data, hideErrors: true });
      }
    });
  };
}

function playStopStat() {
  return function (dispatch, getState) {
    var _getState$audioplayer = getState().audioplayer,
        session = _getState$audioplayer.playSession,
        trackNumber = _getState$audioplayer.currentTrackIndex,
        tracks = _getState$audioplayer.tracks,
        playerStatus = _getState$audioplayer.playerStatus;

    var isPlayerRunning = [_AudioPlayer2.default.status.play, _AudioPlayer2.default.status.pause].includes(playerStatus);

    if (isPlayerRunning && tracks.length && session) {
      dispatch((0, _playstats.increasePlaysCount)({ trackId: (0, _get4.default)(tracks, [trackNumber, 'id']) }));
      var data = dispatch(getStatRequestData({ session: session, trackNumber: trackNumber }));
      var isUser = dispatch((0, _auth.isLoggedIn)());
      return dispatch({
        types: loadReducer.constantsByKey.playStopStat,
        promise: function promise(client) {
          return client.post(isUser ? 'viewer_wa/play_stop' : 'auth/play_stop', { data: data, hideErrors: true });
        }
      });
    }
  };
}

function playPauseStat(_ref3) {
  var session = _ref3.session,
      trackNumber = _ref3.trackNumber;

  return function (dispatch) {
    var data = dispatch(getStatRequestData({ session: session, trackNumber: trackNumber }));
    var isUser = dispatch((0, _auth.isLoggedIn)());
    dispatch({
      types: loadReducer.constantsByKey.playPauseStat,
      promise: function promise(client) {
        return client.post(isUser ? 'viewer_wa/pause_start' : 'auth/pause_start', { data: data, hideErrors: true });
      }
    });
  };
}

function playUnpauseStat(_ref4) {
  var session = _ref4.session,
      trackNumber = _ref4.trackNumber;

  return function (dispatch) {
    var data = dispatch(getStatRequestData({ trackNumber: trackNumber, session: session }));
    var isUser = dispatch((0, _auth.isLoggedIn)());
    dispatch({
      types: loadReducer.constantsByKey.playUnpauseStat,
      promise: function promise(client) {
        return client.post(isUser ? 'viewer_wa/pause_stop' : 'auth/pause_stop', { data: data, hideErrors: true });
      }
    });
  };
}

function playPlayStat() {
  return function (dispatch, getState) {
    var _getState$audioplayer2 = getState().audioplayer,
        session = _getState$audioplayer2.playSession,
        trackNumber = _getState$audioplayer2.currentTrackIndex;

    var data = dispatch(getStatRequestData({ trackNumber: trackNumber, session: session }));
    var isUser = dispatch((0, _auth.isLoggedIn)());
    dispatch({
      types: loadReducer.constantsByKey.playPlayStat,
      promise: function promise(client) {
        return client.post(isUser ? 'viewer_wa/play_play' : 'auth/play_play', { data: data, hideErrors: true });
      }
    });
  };
}

function getNextTrackInfo(tracks, currentTrackIndex) {
  return function (dispatch) {
    if (!Array.isArray(tracks)) {
      return {};
    }

    var _dispatch2 = dispatch((0, _playstats.getAllowedTracksInfo)({ tracks: tracks, currentTrackIndex: currentTrackIndex })),
        allowedNextIndex = _dispatch2.allowedNextIndex;

    var track = allowedNextIndex !== null ? tracks[allowedNextIndex] : {};
    return { index: allowedNextIndex, track: track };
  };
}

function getPrevTrackInfo(tracks, currentTrackIndex) {
  return function (dispatch) {
    if (!Array.isArray(tracks)) {
      return {};
    }

    var _dispatch3 = dispatch((0, _playstats.getAllowedTracksInfo)({ tracks: tracks, currentTrackIndex: currentTrackIndex })),
        allowedPrevIndex = _dispatch3.allowedPrevIndex;

    var track = allowedPrevIndex !== null ? tracks[allowedPrevIndex] : {};
    return { index: allowedPrevIndex, track: track };
  };
}

function trackPosition() {
  return function (dispatch) {
    var runUpdate = function runUpdate() {
      return dispatch(updatePosition(_AudioPlayer2.default.getPosition()));
    };
    runUpdate();
    clearInterval(positionInterval);
    positionInterval = setInterval(runUpdate, 500);
  };
}

function stopTrackPosition() {
  clearInterval(positionInterval);
}

function trackPlayStat() {
  return function (dispatch) {
    var runUpdate = function runUpdate() {
      return dispatch(playPlayStat());
    };
    clearInterval(playStatInterval);
    playStatInterval = setInterval(runUpdate, playStatDelay);
  };
}

function stopTrackPlayStat() {
  clearInterval(playStatInterval);
}

function getPlayerTrack() {
  var track = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return { src: track.audioSrc, title: track.trackName };
}

function playAudio() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      track = _ref5.track,
      nextTrack = _ref5.nextTrack;

  return function (dispatch) {
    _AudioPlayer2.default.play(getPlayerTrack(track), getPlayerTrack(nextTrack));
    _AudioPlayer2.default.off('ended', endedHandler);
    endedHandler = function endedHandler() {
      return dispatch(playNext(true));
    }; // eslint-disable-line no-use-before-define
    _AudioPlayer2.default.on('ended', endedHandler);
    dispatch(trackPosition());
    dispatch(trackPlayStat());
  };
}

function pause() {
  return function (dispatch, getState) {
    var state = getState().audioplayer;
    stopTrackPosition();
    stopTrackPlayStat();
    if (_AudioPlayer2.default.getAudio()) {
      _AudioPlayer2.default.pause();
    }
    dispatch(playPauseStat({ trackNumber: state.currentTrackIndex, session: state.playSession }));
    return dispatch({ type: PAUSE });
  };
}

function unpause() {
  return function (dispatch, getState) {
    var state = getState().audioplayer;
    dispatch(playAudio());
    dispatch(playUnpauseStat({ trackNumber: state.currentTrackIndex, session: state.playSession }));
    dispatch({ type: PLAY });
  };
}

function stop() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref6$sendStat = _ref6.sendStat,
      sendStat = _ref6$sendStat === undefined ? true : _ref6$sendStat;

  return function (dispatch) {
    if (sendStat) {
      dispatch(playStopStat());
    }
    if (_AudioPlayer2.default.getAudio()) {
      _AudioPlayer2.default.stop();
    }
    stopTrackPosition();
    stopTrackPlayStat();

    dispatch({
      type: STOP
    });
  };
}

function albumEnded(isAlbumEnded) {
  return {
    type: ALBUM_ENDED,
    isAlbumEnded: isAlbumEnded
  };
}

function albumDenied() {
  return {
    type: ALBUM_DENIED
  };
}

function flushAlbumDeniedFlag() {
  return {
    type: FLUSH_ALBUM_DENIED_FLAG
  };
}

function togglePause() {
  return function (dispatch, getState) {
    var state = getState().audioplayer;
    if (state.playerStatus === _AudioPlayer2.default.status.play) {
      dispatch(pause());
    } else {
      dispatch(unpause());
    }
  };
}

function checkAlbumDenied(_ref7) {
  var tracks = _ref7.tracks;

  return function (dispatch) {
    var _dispatch4 = dispatch((0, _playstats.getAllowedTracksInfo)({ tracks: tracks })),
        allowedTracks = _dispatch4.allowedTracks;

    var isDenied = !allowedTracks.length;
    if (isDenied) {
      dispatch(stop({ sendStat: false }));
      dispatch(albumDenied());
    }

    return isDenied;
  };
}

function checkTrackDenied(_ref8) {
  var _ref8$track = _ref8.track,
      track = _ref8$track === undefined ? {} : _ref8$track;

  return function (dispatch) {
    return !dispatch((0, _playstats.isCanPlay)({ trackId: track.id }));
  };
}

function getFirstAllowedTrackIndex(_ref9) {
  var tracks = _ref9.tracks;

  return function (dispatch) {
    var _dispatch5 = dispatch((0, _playstats.getAllowedTracksInfo)({ tracks: tracks })),
        allowedIndexes = _dispatch5.allowedIndexes;

    return allowedIndexes.length ? allowedIndexes[0] : null;
  };
}

function playAlbumTrack(_ref10) {
  var album = _ref10.album,
      tracks = _ref10.tracks,
      currentTrackIndex = _ref10.currentTrackIndex;

  return function (dispatch) {
    var nextTrack = (0, _get4.default)(dispatch(getNextTrackInfo(tracks, currentTrackIndex)), 'track');
    dispatch(playAudio({ track: tracks[currentTrackIndex], nextTrack: nextTrack }));

    dispatch({
      type: PLAY_ALBUM,
      album: album,
      tracks: tracks,
      currentTrackIndex: currentTrackIndex
    });

    dispatch(playStartStat(currentTrackIndex));
  };
}

function playAlbum() {
  var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      album = _ref11.album,
      tracks = _ref11.tracks,
      currentTrackIndex = _ref11.currentTrackIndex;

  return function (dispatch, getState) {
    var index = (0, _isUndefined3.default)(currentTrackIndex) ? dispatch(getFirstAllowedTrackIndex({ tracks: tracks })) : currentTrackIndex;
    var state = getState().audioplayer;
    var isSameAlbum = album.recipient_id && state.album.recipient_id === album.recipient_id || !album.recipient_id && state.album.projectId === album.projectId;
    var isSameTrackIndex = state.currentTrackIndex === index && index !== null;
    var isSameTrack = isSameAlbum && isSameTrackIndex;

    if (isSameTrack) {
      return dispatch(togglePause());
    }

    var isTrackDenied = index === null || dispatch(checkTrackDenied({ track: tracks[index] }));
    var isAlbumDenied = dispatch(checkAlbumDenied({ tracks: tracks }));
    if (!isTrackDenied) {
      dispatch(playStopStat());
      if (!isAlbumDenied) {
        dispatch(playAlbumTrack({ album: album, tracks: tracks, currentTrackIndex: index }));
      }
    }
  };
}

function playPause() {
  if (_AudioPlayer2.default.getAudio()) {
    return function (dispatch) {
      return dispatch(togglePause());
    };
  }
}

function setVolume(volume) {
  var isVolumeNeedUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return function (dispatch) {
    _AudioPlayer2.default.volume(Number(volume));
    dispatch({
      type: SET_VOLUME,
      volume: Number(volume),
      isVolumeNeedUpdate: isVolumeNeedUpdate
    });
  };
}

function seek(position) {
  return function (dispatch) {
    if (_AudioPlayer2.default.getAudio()) {
      _AudioPlayer2.default.seek(position);
      dispatch({
        type: SEEK,
        position: position,
        humanizedPosition: _AudioPlayer2.default.getHumanizedPosition(position)
      });
    }
  };
}

function play() {
  if (_AudioPlayer2.default.getAudio()) {
    _AudioPlayer2.default.play();
  }
  return {
    type: PLAY
  };
}

function tryPlayTrack(_ref12) {
  var track = _ref12.track,
      index = _ref12.index;

  return function (dispatch, getState) {
    var state = getState().audioplayer;
    var isAlbumDenied = dispatch(checkAlbumDenied({ tracks: state.tracks }));

    if (!isAlbumDenied && track) {
      var trackAfter = (0, _get4.default)(dispatch(getNextTrackInfo(state.tracks, index)), 'track');
      dispatch(playAudio({ track: track, nextTrack: trackAfter }));
      dispatch(playStartStat(index));

      dispatch({
        type: PLAY_TRACK,
        currentTrackIndex: index
      });
    }
  };
}

function playNext() {
  var isCheckAlbumEnd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return function (dispatch, getState) {
    dispatch(playStopStat());

    var state = getState().audioplayer;

    var _dispatch6 = dispatch(getNextTrackInfo(state.tracks, state.currentTrackIndex)),
        index = _dispatch6.index,
        track = _dispatch6.track;

    if (index === 0 && isCheckAlbumEnd) {
      dispatch(stop({ sendStat: false }));
      return dispatch(albumEnded(true));
    }

    dispatch(tryPlayTrack({ track: track, index: index }));
  };
}

function playPrev() {
  return function (dispatch, getState) {
    dispatch(playStopStat());

    var state = getState().audioplayer;

    var _dispatch7 = dispatch(getPrevTrackInfo(state.tracks, state.currentTrackIndex)),
        index = _dispatch7.index,
        track = _dispatch7.track;

    dispatch(tryPlayTrack({ track: track, index: index }));
  };
}

function toggleExpand() {
  return {
    type: TOGGLE_EXPAND
  };
}

function updateAlbumName(_ref13) {
  var name = _ref13.name;

  return {
    type: UPDATE_ALBUM_NAME,
    name: name
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/audioplayer.js
// module id = 83
// module chunks = 1